/*
 * Shared column body renderers so the "show N/A when empty" fallback is defined
 * once, instead of being copy-pasted (in several drifted variants) into every
 * list's *.ui.tsx.
 */

import { ReactNode } from 'react';

// Default cell: render the value, or "N/A" when it is empty/missing.
export const naBody =
  (field: string) =>
  (row: Record<string, any>): ReactNode =>
    !row?.[field] ? 'N/A' : row[field];
